import { render, staticRenderFns } from "./reg_planing.vue?vue&type=template&id=306b64e0&"
import script from "./reg_planing.vue?vue&type=script&lang=js&"
export * from "./reg_planing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports